__turbopack_context__.v({
  "iconsContainer": "LookImage-module-scss-module__pJtALG__iconsContainer",
  "lookImageRoot": "LookImage-module-scss-module__pJtALG__lookImageRoot",
  "stickerLabelContainer": "LookImage-module-scss-module__pJtALG__stickerLabelContainer",
});
